import CVSection from './CVSection.tsx';

interface CVSectionData {
  title: string;
  description: string;
}

function CVSummary(): JSX.Element {
  const cvSections: CVSectionData[] = [
    {
      title: "Professional Summary",
      description: "9+ years full-stack developer specializing in AI frameworks, DDD, microservices, PHP/Laravel, Python/FastAPI, React/Vue.js/TypeScript, AWS, Kubernetes"
    },
    {
      title: "Work Experience",
      description: "Fuel2 (2025-Present), SenPrints (2021-2024), Zotabox (2019-2021), FPTSoftware (2018-2019), EGDGroup (2016-2018)"
    },
    {
      title: "Key Achievements",
      description: "Multi-agent AI framework, 60% AWS cost reduction, 92% rendering optimization"
    },
    {
      title: "Technical Skills",
      description: "Python, FastAPI, React, TypeScript, JavaScript, PHP, Vue.js, Node.js, Laravel, PostgreSQL, Redis, Kafka, AWS, Kubernetes, Docker"
    },
    {
      title: "Certification",
      description: "CS50's Introduction to Artificial Intelligence with Python — Harvard University (2026); Enterprise AI Business Solutions — IBM SkillsBuild (issued 2026)"
    },
    {
      title: "Open Source Contributions",
      description: "Seiretsu, Online Video Platform, VideoAutoComposition, PiCloud"
    }
  ];

  return (
    <div className="p-6">
      <h2 className="text-2xl font-bold text-gray-800 mb-6">CV Summary</h2>
      <div className="grid gap-6 md:grid-cols-2">
        {cvSections.map((section: CVSectionData, index: number) => (
          <CVSection
            key={index}
            title={section.title}
            description={section.description}
          />
        ))}
      </div>
    </div>
  );
}

export default CVSummary;
